import React from "react";
import "./ConfirmModal.css";

const ConfirmModal = ({ show, onConfirm, onCancel }) => {
  if (!show) return null;

  return (
    <div className="mc-modal-overlay">
      <div className="mc-modal">
        <img
          src="/assets/logo-mesaclick.png"
          alt="MesaClick"
          className="mc-modal-logo"
        />

        <p className="mc-modal-text">Tem certeza que deseja excluir este item?</p>

        <div className="mc-modal-actions">
          <button className="mc-btn-cancel" onClick={onCancel}>
            Cancelar
          </button>
          <button className="mc-btn-confirm" onClick={onConfirm}>
            Excluir
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmModal;
